import * as React from 'react'

import {
  GoToPaymentButton as SharedGoToPaymentButton,
  useSelectedPaymentMethodCtx,
} from '~shared/segments/OrderLockedScreen'

import { useLayoutIsXS } from '../../../segments/Responsive/client'
import { useOrderReSubmit } from '../hooks/useOrderReSubmit'

type TProps = NoChildren

/**
 * Button that will handle the submit of the changed payment method.
 */
export const GoToPaymentButton: React.FC<TProps> = () => {
  const { submitOrder } = useOrderReSubmit()
  const paymentMethod = useSelectedPaymentMethodCtx()
  const isMobile = useLayoutIsXS()

  return (
    <SharedGoToPaymentButton
      isMobile={isMobile}
      onSubmitOrder={() => submitOrder({ paymentMethod })}
    />
  )
}
